var map = {
	"./al.jpg": "9a5e",
	"./banchetto-martello.jpg": "c650",
	"./biberon.jpg": "387c",
	"./cane-oko.jpg": "f35e",
	"./coperta_bamboom.jpg": "05fc",
	"./culla_interbaby.jpg": "813c",
	"./davide.jpg": "73fb",
	"./esatto3.jpg": "f143",
	"./esatto3.png": "448b",
	"./family1.png": "4579",
	"./family2.png": "a1db",
	"./free-offer.png": "17ee",
	"./gallina-traino.jpg": "61b2",
	"./gatto-musicale.jpg": "9399",
	"./giostrina-animali.jpg": "d6be",
	"./giraffa-traino.jpg": "b2d7",
	"./info-1.jpg": "baac",
	"./info-10.jpg": "0537",
	"./info-2.jpg": "350a",
	"./info-3.jpg": "597d",
	"./info-4.png": "9bd3",
	"./info-5.jpg": "f704",
	"./inserti_pannolino.jpg": "719d",
	"./isofix.jpg": "a3f5",
	"./it.jpg": "6d04",
	"./lettino_azzurra.jpg": "d8d5",
	"./lettino_campeggio.jpg": "b30d",
	"./maialino.jpg": "76a6",
	"./marsupio.jpg": "df9f",
	"./orsetto.jpg": "0ffa",
	"./pannolino_lavabile.jpg": "ee3b",
	"./pinguino.jpg": "601f",
	"./prolunga.jpg": "22ef",
	"./puzzle-treno.jpg": "a27b",
	"./sdraietta.jpg": "34527",
	"./set_copripiumino_flying.jpg": "97d5",
	"./set_copripiumino_space.jpg": "a3d1",
	"./set_primo_bagnetto.jpg": "f89e",
	"./sonaglio.jpg": "02fc",
	"./spirale_gioco.jpg": "d733",
	"./swaddle_muslin.jpg": "7d47",
	"./tappeto_gioco.jpg": "5809",
	"./telo_bagnetto.jpg": "b453",
	"./topo.jpg": "e5ba",
	"./trenino-legno.jpg": "8c1c",
	"./trio.jpg": "c267",
	"./uk.jpg": "8b8e",
	"./xilofono-tigre.jpg": "a3ac"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";